/**
 * Os desenhos do menu.
 *
 * Inline, e nao de uma biblioteca: qualquer pacote de icones traz centenas
 * deles e o navegador baixa todos para usar dez. Sao doze caminhos de SVG —
 * custa menos escrever que instalar.
 *
 * Cada um e `aria-hidden`, porque o nome do item ja esta escrito ao lado. Um
 * icone com rotulo proprio faria o leitor de tela anunciar tudo duas vezes.
 */

export type NomeDoIcone =
  | 'dashboard'
  | 'contas'
  | 'lancamentos'
  | 'patrimonio'
  | 'categorias'
  | 'notificacoes'
  | 'a-pagar'
  | 'importar'
  | 'conexoes'
  | 'regras'
  | 'casa'
  | 'seguranca';

const CAMINHOS: Record<NomeDoIcone, string> = {
  dashboard: 'M3 13h7V3H3zM14 21h7V11h-7zM14 8h7V3h-7zM3 21h7v-5H3z',
  contas: 'M3 7h18v12H3zM3 11h18M7 15h3',
  lancamentos: 'M4 5h16M4 12h16M4 19h10M17 17l2 2 3-3',
  patrimonio: 'M3 21h18M5 21V9l7-5 7 5v12M10 21v-6h4v6',
  categorias: 'M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z',
  notificacoes: 'M18 9a6 6 0 1 0-12 0c0 5-2 7-2 7h16s-2-2-2-7M10 21h4',
  'a-pagar': 'M8 3v4M16 3v4M4 9h16M4 7h16v13H4zM9 14h6',
  importar: 'M12 3v11M8 10l4 4 4-4M4 19h16',
  conexoes: 'M9 12a4 4 0 0 1 4-4h3a4 4 0 0 1 0 8h-1M15 12a4 4 0 0 1-4 4H8a4 4 0 0 1 0-8h1',
  regras: 'M4 6h10M18 6h2M4 12h4M12 12h8M4 18h12M20 18h0M16 4v4M10 10v4M18 16v4',
  casa: 'M3 10l9-7 9 7v10H3zM9 20v-6h6v6',
  seguranca: 'M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6zM9 12l2 2 4-4',
};

export function Icone({ nome }: { nome: NomeDoIcone }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden focusable="false">
      <path d={CAMINHOS[nome]} />
    </svg>
  );
}
